<template>
    <AppModal ref="modal" :title="$t('groupProductModal.modalTitle')" size="lg" @on-hide="hide">
        <div class="modal-body">
            <TaskProgressBar v-if="task.state.isRunning" :done="task.state.done" :total="task.state.total"/>
            <template v-else>
                <Alert type="info" class="mb-4">
                    <span>{{ $t('groupProductModal.groupProductsInfoFirst') }}<b>{{` "${$t('labels.group_id')}"`}}</b>.</span><br>
                    {{ $t('groupProductModal.groupProductsInfoSecond') }}
                </Alert>
                <div class="row mb-3">
                    <div class="col-lg-6">
                        <InputGroup>
                            <Radio :model-value="selectedGrouping === 'manual'" @click="selectedGrouping = 'manual'"/>
                            <template #append>{{ $t('groupProductModal.manualGroupId') }}</template>
                        </InputGroup>
                    </div>
                    <div class="col-lg-6">
                        <InputGroup>
                            <Radio :model-value="selectedGrouping === 'available'" @click="selectedGrouping = 'available'"/>
                            <template #append>{{ $t('groupProductModal.selectAvailableGroupId') }}</template>
                        </InputGroup>
                    </div>
                </div>
                <FormGroup :label="$t('labels.group_id')">
                    <template v-if="selectedGrouping === 'manual'">
                        <InputGroup>
                            <Input :placeholder="placeholder" v-model="groupKey"/>
                            <template #append>
                                <AppButton color="light" @click="groupKey = placeholder">
                                    {{ $t('buttons.generate') }}
                                </AppButton>
                            </template>
                        </InputGroup>
                    </template>
                    <template v-else>
                        <AppSelect
                            :options="availableGroupIds"
                            v-model="groupKey"
                            @update:model-value="(value) => groupKey = value.key"
                            :selected-value="groupKey"
                            option-key="key"
                            option-value="value"
                        />
                    </template>
                </FormGroup>
            </template>
        </div>
        <div class="modal-footer d-flex justify-content-end" v-if="!task.state.isRunning">
            <AppButton color="light" @click="hide">
                {{ $t('groupProductModal.cancelButton') }}
            </AppButton>
            <AppButton color="indigo" @click="groupProducts">
                {{ $t('groupProductModal.groupButton') }}
            </AppButton>
        </div>
    </AppModal>
</template>
<script>
import AppModal from '../../../../../../components/new/modal/AppModal.vue';
import Alert from "../../../../../../components/AlertComponent.vue";
import InputGroup from '../../../../../../components/new/form/InputGroup.vue';
import Radio from '../../../../../../components/new/form/radio/Radio.vue';
import FormGroup from '../../../../../../components/new/form/group/FormGroup.vue';
import Input from '../../../../../../components/new/form/Input.vue';
import AppSelect from '../../../../../../components/new/form/select/AppSelect.vue';
import AppButton from '../../../../../../components/new/button/AppButton.vue';
import TaskProgressBar from '../../../../../../components/new/progress/TaskProgressBar.vue';

import { httpClient } from '../../../../../../services/HttpClient';
import HttpSender from '../../../../../../services/Http/HttpSender';
import HttpRequest from '../../../../../../services/Http/HttpRequest';
import { createProgressTask } from '../../../../../../services/Progress/ProgressTask';

export default {
    name: 'GroupProductModal',
    components: {
        AppModal, Alert, InputGroup, Radio, FormGroup, Input, AppSelect, AppButton, TaskProgressBar
    },
    emits: ['products:grouped'],
    data() {
        return {
            task: createProgressTask(),
            products: [],
            selectedGrouping: "manual",
            placeholder: '',
            groupKey: null,
            availableGroupIds: []
        };
    },
    methods: {
        async show(productUuids) {
            this.placeholder = this.generateGroupId();

            await httpClient.get(`/integrations/${this.$route.params.integrationUuid}/products`, {
                uuids: productUuids,
                limit: 100
            }).then(response => {
                this.products = response.data.data;
                response.data.data.forEach(product => {
                    if (product.group_key) {
                        if (!this.availableGroupIds.some(group => group.key === product.group_key)) {
                            this.availableGroupIds.push({
                                key: product.group_key,
                                value: product.group_key
                            });
                        }
                    }
                })
            })

            this.$refs.modal.show();
        },
        hide() {
            this.task.cancel();
            this.$refs.modal.hide();
            this.groupKey = null;
            this.availableGroupIds = [];
            this.selectedGrouping = "manual";
            this.products = [];
        },
        generateGroupId() {
            return Math.floor(100000 + Math.random() * 900000);
        },
        async groupProducts() {
            const requests = this.products
                .filter(product => product.group_key !== this.groupKey)
                .map(product => new HttpRequest('PATCH', `/integrations/products/${product.uuid}`, {
                    group_key: this.groupKey.toString()
                }));

            const completed = await this.task.run(async ({setTotal, tick}) => {
                setTotal(requests.length);

                await new HttpSender().sendRequestsInBatches(requests, () => tick());
            });

            if (completed) {
                this.hide();
                this.$emit('products:grouped');
            }
        }
    },
    beforeUnmount() {
        this.task.cancel();
    }
}
</script>